import MNoIvrAutomaticVoiceGuidance from './index.vue';

MNoIvrAutomaticVoiceGuidance.install = app => {
  app.component(MNoIvrAutomaticVoiceGuidance.name, MNoIvrAutomaticVoiceGuidance);
};

export default MNoIvrAutomaticVoiceGuidance;
